<div class="modal-header">
    Verifica dei documenti inviati
    <div class="card-tools">
        <button type="button" class="btn btn-tool" (click)="cancel()" >
          <i class="fas fa-times"></i>
        </button>
    </div>
</div>
<div class="modal-body" style="max-height:80vh; overflow-y:auto">
    <div class="my-5 text-center" *ngIf="loading">
        <i class="fas fa-spinner fa-spin fa-2x text-primary mb-2"></i><br>
        <i class="fas fa-cloud-download-alt mr-2"></i>Scaricamento informazioni in corso...<br>La procedura potrebbe impiegare diversi minuti!<br>
        <button type="button" class="btn btn-outline-secondary mt-3" (click)="cancel()" >Annulla</button>
    </div>
    <ng-container *ngIf="!loading">
        <div class="row pb-2">
            <div class="col-lg-6 text-lg-right">
                <label>Visualizza tutti i documenti a partire da 30 giorni prima rispetto alla data</label>
            </div>
            <div class="col-lg-2">
                <div class="input-group input-group-sm">
                    <input type="date" class="form-control form-control-sm" [(ngModel)]="date_search" (change)="getList()">
                    <div class="input-group-append">
                        <button class="btn btn-default text-primary" (click)="getList()"><i class="fa fa-search"></i></button>    
                    </div>
                </div>
            </div>
            <div class="col-4">
            </div>
        </div>
        <table class="table">            
            <thead>
                <th>ID documento</th>
                <th class="py-1 text-center">Numero</th>
                <th class="py-1 text-center">Data</th>
                <th class="py-1">Cliente</th>
                <th class="py-1 text-center">Totale</th>            
                <th class="py-1 text-center">Stato nel DB</th>
                <th class="py-1 text-center">Stato sullo SdI</th>
                <th class="py-1 text-center">Aggiornato</th>
                <th class="py-1 text-center">Identificativo SdI</th>                
            </thead>
            <tr *ngFor="let record of list">
                <td class="py-1">
                    <small *ngIf="record.id==0">
                        <div class="badge badge-warning">Non presente</div>
                    </small>    
                    <ng-container *ngIf="record.id>0">
                        {{record.id}}
                    </ng-container>
                </td>
                <td class="py-1 text-center">{{record.number}}</td>
                <td class="py-1 text-center">{{record.date | date:"d-M-Y"}}</td>
                <td class="py-1"><b>{{record.name}}</b></td>
                <td class="py-1 text-center">{{record.total | currency:"EUR"}}</td>
                <td class="py-1 text-center">
                    <small *ngIf="record.old_status==1"><i class="text-warning fa fa-clock mr-2"></i>(Inviata)</small>
                    <small *ngIf="record.old_status==2"><i class="text-success fa fa-check mr-2"></i>(Consegnata)</small>
                    <small *ngIf="record.old_status==4"><i class="text-primary fa fa-check mr-2"></i>(Confermata)</small>
                    <small *ngIf="record.old_status==3"><i class="text-danger fa fa-exclamation-triangle mr-2"></i>(Errore)</small>
                </td>
                <td class="py-1 text-center">
                    <small *ngIf="record.new_status==1"><i class="text-warning fa fa-clock mr-2"></i>(Inviata)</small>
                    <small *ngIf="record.new_status==2"><i class="text-success fa fa-check mr-2"></i>(Consegnata)</small>
                    <small *ngIf="record.new_status==4"><i class="text-primary fa fa-check mr-2"></i>(Confermata)</small>
                    <small *ngIf="record.new_status==3"><i class="text-danger fa fa-exclamation-triangle mr-2"></i>(Errore)</small>
                </td>
                <td class="py-1 text-center">
                    <span *ngIf="!record.change && record.new_status==3">
                        <span *ngIf="!record.change && record.new_status==3" class="badge badge-warning">No</span>
                        <i title="Il documento risulta regolarmente consegnato con un altro invio." class="fas fa-question ml-2"></i>
                    </span>
                    <span *ngIf="record.change" class="badge badge-success">Sì</span>
                </td>
                <td class="py-1 text-center">
                    {{record.sdi_invoice_new}}
                </td>
            </tr>
        </table>
        <div *ngIf="!list || list.length==0" class="m-5 text-center text-secondary">
            <i class="icon fas fa-info-circle mr-2"></i><i>Nessuna fattura da visualizzare</i>
        </div>
    </ng-container>
</div>
<div class="modal-footer">        
    <button class="btn btn-sm btn-secondary" (click)="cancel()">Chiudi</button>
</div>